import { useEffect, useState } from 'react';

// enum SentimentString {
//   POSITIVE = "Positive",
//   NEGATIVE = "Negative",
//   NEUTRAL = "Neutral",
//   MIXED = "Mixed",
// }

type SentimentResponse = {
  Sentiment: string;
  SentimentScore: {
    Mixed: number;
    Negative: number;
    Neutral: number;
    Positive: number;
  };
};

function analyseText(text: string) {
  return fetch(
    'https://qggistmnz6.execute-api.eu-west-2.amazonaws.com/default/Comprehend',
    {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({ text: text }),
    }
  ).then(async response => {
    if (response.ok && response.status === 200) {
      const res = await response.json();
      if (typeof res == 'string') {
        return null;
      }
      return res;
    } else {
      return null;
    }
  });
}

export const useSentiment: Function = (input: string) => {
  const [
    sentimentResponse,
    setSentimentResponse,
  ] = useState<SentimentResponse | null>(null);

  const [loadingSentiment, setLoadingSentiment] = useState<boolean>(false);

  useEffect(() => {
    //debounce the call so we don't run up a huge AWS bill!
    const timeout = setTimeout(() => {
      if (input) {
        setLoadingSentiment(true);
        analyseText(input).then(response => {
          if (response) {
            setSentimentResponse(response);
          }
          setLoadingSentiment(false);
        });
      }
    }, 500);
    return () => clearTimeout(timeout);
  }, [input]);

  return [sentimentResponse, loadingSentiment];
};
